import { Container, Row, Col, Button, Form } from 'react-bootstrap';
import { useRef } from 'react';
import '../../App.css';
import '../../css/bootstrap.scss';
import user_icon from "../../images/reg_user.png";
import { Link } from 'react-router-dom';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import { useNavigate } from 'react-router-dom';
import BackButton from '../Includes/BackButton';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function SecureIdentityVerification() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [validated, setValidated] = useState(false);

    return (
        <>
            <Header />
            <Container fluid className='bg-sky min-vh-custom'>
                <Row>
                    <Col md={12}>
                        <div className='mt-5'>
                            <Col md={3} className='text-center py-4'>
                                <Row className='justify-content-center'>
                                    <BackButton />
                                </Row>
                            </Col>

                            <Col md={12} className='text-center justify-content-center'>
                                <img src={user_icon} width={50} />
                                <h3 className='text-center mt-3'>{t('login.secure_title')}</h3>

                                <Row className='justify-content-center text-center'>
                                    <Col md={4} className='bg-white rounded-3 my-4' style={{ width: '540px' }}>
                                        <Form noValidate validated={validated}>
                                            <Row className="mb-3">
                                                <label className="form-label mt-3">{t('login.secure_subtitle')}</label>
                                                <span className='text-secondary small'>
                                                    {t('login.secure_data')}
                                                    <Link to={""} className='text-primary'> Privacy Policy.</Link>
                                                    <br />{t('login.secure_have_id')}
                                                </span>
                                            </Row>

                                            <Row className='justify-content-center'>
                                                <Col md={8}>
                                                    <Row className='m-0 d-flex align-items-center py-4 text-center'>
                                                        <Button type="submit" variant='' className="btn rounded-5 border-0 text-white" style={{ background: '#0B1628' }} onClick={() => { navigate('/secure_identity_verify_next_phase') }}>{t('login.get_started')}</Button>
                                                        <Link to={""} className='text-primary mt-3 mb-2'>{t('login.complete_mobile')}</Link>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                            </Col>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Footer full={true} />
        </>
    );
}

export default SecureIdentityVerification;
